import Sentiment from "sentiment";

const sentiment = new Sentiment();

export const analyzeSentiment = (text: string) => {
  return sentiment.analyze(text);
}